<template>
  <div style="width: 100%;">
    <div class="mdl-progress mdl-js-progress mdl-progress__indeterminate">
      Cargando...
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
  mounted () {
    componentHandler.upgradeElement(this.$el.childNodes[0])
  }
}
</script>

<style lang="css" scoped>
  .mdl-progress {
    margin: 2rem auto;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// index.vue?e670c27e